import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  CHART_AXIS_LINE,
  CHART_AXIS_TICK,
  CHART_GRID_PROPS,
  CHART_SERIES_PRIMARY,
  CHART_TOOLTIP_STYLE,
} from "./chartTheme.ts";

export function ResultsDashboardMiniChart({
  data,
  height = 160,
}: {
  data: { time: string; value: number }[];
  height?: number;
}) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: -20 }}>
        <CartesianGrid {...CHART_GRID_PROPS} />
        <XAxis
          dataKey="time"
          tick={CHART_AXIS_TICK}
          axisLine={CHART_AXIS_LINE}
          tickLine={CHART_AXIS_LINE}
          minTickGap={30}
        />
        <YAxis tick={CHART_AXIS_TICK} axisLine={CHART_AXIS_LINE} tickLine={CHART_AXIS_LINE} />
        <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
        <Line
          type="monotone"
          dataKey="value"
          stroke={CHART_SERIES_PRIMARY}
          dot={false}
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
